// Generated by ts-to-zod
import { z } from 'zod';

export const automationSettingsSchema = z
  .object({
    automateDuplicates: z.boolean(),
    automateSuggestedEdit: z.boolean(),
    automationAssistantEnabled: z.boolean(),
    automationAssistantDemo: z.boolean(),
  })
  .partial();
